import { createSelector } from '@reduxjs/toolkit'
import { IStore } from 'redux/types'

export const selectUser = createSelector(
	(state: IStore) => state.user,
	(userState) => userState
)
